import type { OtpChannel } from "@jti/fe-common";

export const createOtpChannelOptions = ({ viber = false, whatsapp = true } = {}) => [
  { value: "sms", label: "phone.otp.channel.sms.label" },
  ...optionalOption(whatsapp, "whatsapp", "phone.otp.channel.whatsapp.label"),
  ...optionalOption(viber, "viber", "phone.otp.channel.viber.label"),
];

export const optionalOption = (condition: boolean, value: OtpChannel, label: string) =>
  condition ? [{ value, label }] : [];
